import { defineComponent as _defineComponent } from 'vue'
import { useToaster } from '~/composables/_next/useToaster';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';

import type { ToastMessage } from '~/types/ToastMessage';


export default /*#__PURE__*/_defineComponent({
  __name: 'Toaster',
  setup(__props) {

const { toasts, close: closeToast } = useToaster();

/**
 * Gets the background color.
 *
 * @param      {ToastMessage}  toast   The toast
 * @return     {string}        The background color.
 */
function getBackgroundColor(toast: ToastMessage): string {
  return toast.colorVariant ?? 'var(--c-primary-100)';
}

/**
 * Gets the description.
 *
 * @param      {ToastMessage}   toast   The toast
 * @return     {(null|string)}  The description.
 */
function getDescription(toast: ToastMessage): string | null {
  return toast.description ?? null;
}

/**
 * Closes a toast message.
 * It should be triggered by links in the description
 * A filter mechanism was put in place to restrict
 * the links triggering this method.
 *
 * @param      {Event}        event    The event
 * @param      {string}  toastId  The toast identifier
 */
function closeToastMessage(event: Event, toastId: string) {
  const target = event.target as HTMLAnchorElement;
  const linkValue = target.getAttribute('href');

  // Open the cart and closes the toast
  if (linkValue?.includes('#cart')) {
    closeToast(toastId);
  }

  // Open the removed-items modal on checkout and closes the toast
  if (linkValue?.includes('#modal-removed-items')) {
    event.preventDefault();
    const modal: HTMLDialogElement = document.querySelector('dialog.modal-removed-items');
    if (modal?.open) {
      modal.close();
    } else {
      modal.showModal();
    }
    closeToast(toastId);
  }
}

return { __sfc: true,toasts, closeToast, getBackgroundColor, getDescription, closeToastMessage, AzIcon }
}

})